import {
  failureOf,
  isConnectionFailure,
  tagFailure,
  withFailure,
  type PageLoadStep,
} from '@forest/paywall-core'

export interface LoadFailureDialog {
  kind: 'connection' | 'something_went_wrong'
  /** The failure code (ADR 0037). */
  code: string
  description: string
}

/**
 * The dialog a failed read shows: a connection issue with the failure code on
 * the line under its description, or Something Went Wrong with the code in its
 * `[%s]` error code placeholder.
 */
export function loadFailureDialog(
  error: unknown,
  descriptions: { connection: string; somethingWentWrong: string },
): LoadFailureDialog {
  const failure = failureOf(error, 'load')
  if (isConnectionFailure(error)) {
    return {
      kind: 'connection',
      code: failure.code,
      description: withFailure(descriptions.connection, failure),
    }
  }
  return {
    kind: 'something_went_wrong',
    code: failure.code,
    description: descriptions.somethingWentWrong.replace('[%s]', failure.code),
  }
}

/** Runs a read, tagging what it throws with its page-load step. */
export async function inStep<T>(
  step: PageLoadStep,
  work: () => Promise<T>,
): Promise<T> {
  try {
    return await work()
  } catch (error) {
    throw tagFailure(error, step)
  }
}
